import { color } from '@design/templateFns';

export const button = {
  backgroundColor: color('fg'),
  color: color('bg'),
  display: 'inline-block',
  cursor: 'pointer',
  transition: `color 0.3s ease-in-out,
          background-color 0.3s ease-in-out,
          border-color 0.3s ease-in-out`,
  border: '2px solid',
  borderColor: color('fg'),
  borderRadius: '4px',
  textAlign: 'center',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '16px',
  lineHeight: '22px',
  padding: '9px 20px',
  userSelect: 'none',
  textDecoration: 'none',
  outline: 'none',
  '&:not(:disabled):hover': {
    bg: color('gray5'),
    color: color('bg'),
    borderColor: color('gray5'),
  },
  '&:not(:disabled):active': {
    bg: color('gray4'),
    color: color('bg'),
    borderColor: color('gray4'),
  },
  '&:visted': {
    bg: color('gray5'),
    color: color('bg'),
    borderColor: color('gray5'),
  },
  '&:focus': {
    bg: color('fg'),
    color: color('bg'),
    borderColor: color('cta'),
  },
  '&:disabled': {
    border: 'none',
    cursor: 'default',
    bg: color('gray2'),
    color: color('gray5'),
  },

  '@media only screen and (max-width: 768px)': {
    display: 'block',
    fontSize: '14px',
  },
};

export const primaryWhite = {
  ...button,
  backgroundColor: color('bg'),
  color: color('fg'),
  borderColor: color('bg'),

  '&:not(:disabled):hover': {
    bg: color('gray1'),
    borderColor: color('gray1'),
  },
  '&:not(:disabled):active': {
    bg: color('gray2'),
    color: color('fg'),
    borderColor: color('gray2'),
  },
  '&:focus': {
    bg: color('bg'),
    borderColor: color('cta'),
  },
};

export const primaryRed = {
  ...button,
  backgroundColor: color('cta'),
  borderColor: color('cta'),
  fontWeight: '500',
  '&:not(:disabled):hover': {
    bg: color('ctaHover'),
    borderColor: color('ctaHover'),
  },
  '&:not(:disabled):active': {
    bg: color('ctaPressed'),
    color: color('bg'),
    borderColor: color('ctaPressed'),
  },
  '&:focus': {
    bg: color('cta'),
    borderColor: color('fg'),
  },
  '@media only screen and (max-width: 600px)': {
    borderRadius: '0',
  },
  '@media only screen and (max-width: 700px)': {
    fontSize: '14px',
    width: '266px',
  },
};

export const secondaryRed = {
  ...button,
  backgroundColor: color('cta'),
  borderColor: color('cta'),
  fontWeight: '500',
  '&:not(:disabled):hover': {
    bg: color('ctaHover'),
    borderColor: color('ctaHover'),
  },
  '&:not(:disabled):active': {
    bg: color('ctaPressed'),
    color: color('bg'),
    borderColor: color('ctaPressed'),
  },
  '&:focus': {
    bg: color('cta'),
    borderColor: color('fg'),
  },
  '@media only screen and (max-width: 600px)': {
    borderRadius: '0',
  },
  '@media only screen and (max-width: 700px)': {
    fontSize: '14px',
  },
};

export const secondary = {
  ...button,
  backgroundColor: 'transparent',
  border: '1px solid',
  borderColor: color('fg'),
  color: color('fg'),
  '&:not(:disabled):hover': {
    bg: 'transparent',
    borderColor: color('gray4'),
  },
  '&:not(:disabled):active': {
    bg: color('gray1'),
    color: color('gray3'),
    borderColor: color('gray2'),
  },
  '&:focus': {
    bg: 'transparent',
    color: color('fg'),
    boxShadow: `0px 0px 0px 2px ${color('fg')()}`, // used instead of increasing border size to avoid layout shift
    borderColor: color('fg'),
  },
};

export const secondaryGray = {
  ...secondary,
  color: color('gray4'),
  borderColor: color('gray4'),
  '&:not(:disabled):hover': {
    color: color('gray5'),
  },
  '&:not(:disabled):active': {
    bg: color('bg'),
    color: color('gray5'),
    borderColor: color('gray2'),
  },
  '&:focus': {
    bg: color('bg'),
    color: color('gray4'),
    boxShadow: `0px 0px 0px 2px ${color('fg')()}`,
    borderColor: color('fg'),
  },
};

//this is the 'Read Article' and 'Subscribe' button white with black text, please do not change
export const secondaryWhite = {
  ...secondary,
  bg: 'tranparent',
  color: color('fg'),
  borderColor: color('fg'),
  '&:not(:disabled):hover': {
    color: color('gray5'),
    borderColor: color('gray5'),
  },
  '&:not(:disabled):active': {
    bg: color('gray3'),
    color: color('bg'),
    borderColor: color('gray3'),
  },
  '&:focus': {
    bg: 'tranparent',
    color: color('bg'),
    boxShadow: `0px 0px 0px 2px ${color('bg')()}`,
    borderColor: color('bg'),
  },
};

export const tertiary = {
  ...secondary,
  textDecoration: 'none',
  color: color('fg'),
  bg: 'transparent',
  border: '0',
  padding: '0',
  '&:not(:disabled):hover': {
    color: color('gray5'),
  },
  '&:not(:disabled):active': {
    color: color('gray4'),
    border: '0',
  },
  '&:focus': {
    bg: 'tranparent',
    color: color('fg'),
    boxShadow: `0px 0px 0px 1px ${color('fg')()}`,
    border: '0',
  },
  '&:focus:active': {
    boxShadow: 'none', // to prevent shadow from showing on click
  },
  '&:disabled': {
    color: color('gray4'),
  },
  '@media only screen and (max-width: 768px)': {
    width: 'auto',
    fontSize: '14px',
  },
};

export const tertiaryWhite = {
  ...tertiary,
  color: color('bg'),
  '&:not(:disabled):hover': {
    color: color('gray2'),
  },
  '&:not(:disabled):active': {
    color: color('gray3'),
  },
  '&:focus': {
    bg: 'tranparent',
    color: color('bg'),
    boxShadow: `0px 0px 0px 1px ${color('bg')()}`,
  },
  '&:focus:active': {
    boxShadow: 'none',
  },
  '&:disabled': {
    color: color('gray4'),
  },
};

export const tertiaryGray = {
  ...tertiary,
  color: color('gray4'),
  '&:not(:disabled):hover': {
    color: color('gray5'),
  },
  '&:not(:disabled):active': {
    color: color('fg'),
  },
  '&:focus': {
    bg: 'tranparent',
    color: color('fg'),
    boxShadow: `0px 0px 0px 1px ${color('fg')()}`,
  },
  '&:focus:active': {
    boxShadow: 'none',
  },
  '&:disabled': {
    color: color('gray4'),
  },
};
export const tertiaryGrayDisabled = {
  ...tertiary,
  color: color('gray4'),
  '&:not(:disabled):hover': {
    color: color('gray5'),
  },
  '&:not(:disabled):active': {
    color: color('fg'),
  },
  '&:focus': {
    bg: 'tranparent',
  },
  '&:focus:active': {
    boxShadow: 'none',
  },
  '&:disabled': {
    color: color('gray4'),
  },
};

export const tertiaryBlack = {
  ...tertiary,
  color: color('fg'),
  '&:not(:disabled):hover': {
    color: color('gray5'),
  },
  '&:not(:disabled):active': {
    color: color('gray4'),
  },
  '&:focus': {
    bg: 'tranparent',
    color: color('fg'),
    boxShadow: `0px 0px 0px 1px ${color('fg')()}`,
  },
  '&:focus:active': {
    boxShadow: 'none',
  },
  '&:disabled': {
    color: color('gray4'),
  },
};

export const tertiaryUnderline = {
  ...tertiary,
  color: color('fg'),
  borderRadius: '0',
  borderBottom: '1px solid',
  borderColor: color('fg'),
  '@media only screen and (max-width: 768px)': {
    width: 'auto',
  },
  '&:not(:disabled):hover': {
    color: color('gray5'),
    borderColor: color('gray5'),
  },
  '&:not(:disabled):active': {
    color: color('gray4'),
    borderColor: color('gray4'),
  },
  '&:focus': {
    color: color('fg'),
    borderRadius: '4px',
    boxShadow: `0px 0px 0px 1px ${color('fg')()}`,
  },
  '&:focus:active': {
    boxShadow: 'none',
  },
  '&:disabled': {
    color: color('gray4'),
  },
};

export const iconOnly = {
  color: color('fg'),
  bg: 'transparent',
  border: '0',
  padding: '0',
  '&:not(:disabled):hover': {
    color: color('gray5'),
  },
  '&:not(:disabled):active': {
    color: color('gray4'),
  },
  '&:focus': {
    color: color('fg'),
  },
  '&:focus:active': {
    color: color('fg'),
  },
  '&:disabled': {
    color: color('gray4'),
  },
};
